// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Material/components/ServiceTemperature/styles.scss
// module id = 1355
// module chunks = 0